import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CopilotComponent } from './copilot.component';
import { SharedModule } from '../shared/shared.module';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';
import { DatePicker } from "primeng/datepicker";
import { Select } from "primeng/select";

@NgModule({
  declarations: [
    CopilotComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    InputTextModule,
    TextareaModule,
    MultiSelectModule,
    InputNumberModule,
    DatePicker,
    Select
],
  exports: [
    CopilotComponent
  ]
})
export class CopilotModule { } 